import * as React from 'react';

export interface NavPillsDetailOptions {
    includeDetail?: boolean; // defaults to true. controls whether or not the detail is displayed.
    borderBottom?: boolean; // defaults to true. whether or not to include a bottom border on the pills
    marginBottom?: boolean; // defaults to true. whether or not to include a margin below the pills
}

export interface NavPillsDetailProps {
    localizedNavTitles: string[];
    onNavIndexChanged?: (navIndex: number) => void;
    options?: NavPillsDetailOptions;
}

interface NavPillsDetailState {
    activeNavIndex: number;
}

//
// A nav pills-detail view. A nav pills is on the top, body content on the bottom.
//
// Pass the list of nav titles in the props; the bodies of the different nav endpoints are
// children of the component.
//
// The nav titles are 1-1 correlated to the children bodies by their index order.
//
// You can also use this as just a nav, without a detail body controlled by this component. See options above.
//
export class NavPillsDetail extends React.PureComponent<NavPillsDetailProps, NavPillsDetailState> {
    public constructor(props: NavPillsDetailProps) {
        super(props);

        this.state = {
            activeNavIndex: 0
        };
    }

    // ===============================================================================

    public render() {
        // set up default options

        const options = this.props.options ?? {};

        options.includeDetail ??= true;
        options.borderBottom ??= true;
        options.marginBottom ??= true;

        const activeChildren = React.Children
            .toArray(this.props.children)
            .filter((child, index) => index === this.state.activeNavIndex);

        const pills = (
            <ul className={`nav nav-pills tn-nav-pills ${(options.borderBottom ? "" : "no-border-bottom")} ${(options.marginBottom ? "" : "no-margin-bottom")}`}>
                {this.props.localizedNavTitles.map((localizedNavTitle, index) => (
                    <li key={index} role="presentation" className={(this.state.activeNavIndex === index ? "active" : "")}>
                        <a role="button" onClick={e => this.navPill_click(index)}>{localizedNavTitle}</a>
                    </li>
                ))}
            </ul>
        );

        if (options.includeDetail) {
            return (
                <div className={"nav-pills-detail"}>
                    {pills}
                    <div className="detail">
                        {activeChildren}
                    </div>
                </div>
            );
        }
        else {
            return pills;
        }
    }

    // ===============================================================================

    private navPill_click = (index: number) => {
        this.setState({ activeNavIndex: index });

        if (this.props.onNavIndexChanged && (this.state.activeNavIndex !== index)) {
            this.props.onNavIndexChanged(index);
        }
    }

    // ===============================================================================
}
